<step-navigation *ngIf="((sketches | async)?.length || 0) > 1"></step-navigation>
<div id="sketchesContainer" *ngFor="let sketch of sketches | async; let i = index">
  <p>Schița #{{i + 1}}</p>
  <img src="{{sketch}}"/>
</div>
<p id="errorMessage" *ngIf="!(sketches | async)?.length">Schițele nu au putut fi generate, ați introdus dimensiuni prea mari ?</p>
<step-navigation></step-navigation>
